"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-5727e71e"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "header-text" }, "単発スタッフ", -1 /* HOISTED */));
const _hoisted_2 = ["disabled"];
const _hoisted_3 = {
    key: 0,
    class: "spot-role-cont"
};
const _hoisted_4 = { style: { "font-size": "18px" } };
const _hoisted_5 = { class: "form-padding" };
const _hoisted_6 = {
    for: "industry",
    class: "font-spot-label"
};
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 0 }, "選択してください", -1 /* HOISTED */));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 1 }, "小売", -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 2 }, "ホテル・旅館", -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 3 }, "オフィス・IT", -1 /* HOISTED */));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 4 }, "医療・介護", -1 /* HOISTED */));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 5 }, "配送", -1 /* HOISTED */));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 6 }, "倉庫・物流", -1 /* HOISTED */));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 7 }, "建設", -1 /* HOISTED */));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("option", { value: 8 }, "その他", -1 /* HOISTED */));
const _hoisted_17 = [
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16
];
const _hoisted_18 = { class: "form-padding" };
const _hoisted_19 = {
    for: "input-branch",
    class: "font-spot-label"
};
const _hoisted_20 = { class: "form-padding" };
const _hoisted_21 = {
    for: "input-location",
    class: "font-spot-label"
};
const _hoisted_22 = { class: "form-padding" };
const _hoisted_23 = {
    for: "input-purpose",
    class: "font-spot-label"
};
const _hoisted_24 = { class: "form-padding" };
const _hoisted_25 = {
    for: "input-date",
    class: "font-spot-label"
};
const _hoisted_26 = { class: "form-padding" };
const _hoisted_27 = {
    for: "input-time",
    class: "font-spot-label"
};
const _hoisted_28 = { class: "flex-center flex-gap" };
const _hoisted_29 = ["value"];
const _hoisted_30 = ["value"];
const _hoisted_31 = { class: "form-padding" };
const _hoisted_32 = {
    for: "input-wage",
    class: "font-spot-label"
};
const _hoisted_33 = {
    key: 1,
    class: "form-padding"
};
const _hoisted_34 = {
    for: "input-req-workers",
    class: "font-spot-label"
};
const _hoisted_35 = { class: "form-padding" };
const _hoisted_36 = {
    for: "input-contact",
    class: "font-spot-label"
};
const _hoisted_37 = { class: "form-padding" };
const _hoisted_38 = {
    for: "input-access",
    class: "font-spot-label"
};
const _hoisted_39 = { class: "form-padding" };
const _hoisted_40 = {
    for: "input-additional",
    class: "font-spot-label"
};
const _hoisted_41 = {
    key: 0,
    class: "spot-modal-btn non-verify"
};
const _hoisted_42 = {
    key: 1,
    class: "spot-modal-btn"
};
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("strong", null, "未出勤", -1 /* HOISTED */));
const _hoisted_44 = [
    _hoisted_43
];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../../../vue/Modal.vue"));
const useSpotWorkerShiftForm_1 = require("../composable/useSpotWorkerShiftForm");
const provider_1 = require("../../provider");
const DeleteIcon_vue_1 = __importDefault(require("../../../vue/icons/DeleteIcon.vue"));
const AlertModal_vue_1 = __importDefault(require("../../../vue/AlertModal.vue"));
const VerificationModal_vue_1 = __importDefault(require("./VerificationModal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ShiftModal',
    props: {
        roleId: {},
        selectedShiftId: {}
    },
    emits: ["close-shift-modal"],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        const props = __props;
        const alertModal = (0, vue_3.ref)(null);
        const branch = (0, vue_3.inject)("activeBranch", { id: 0, name: "", groupId: 0, ownerIds: [], employeeIds: [], address: "", groupName: "" });
        const roleStore = (0, vue_3.inject)("roleStore");
        const shiftStore = (0, vue_3.inject)(provider_1.spotShiftStoreKey);
        const employeeStore = (0, vue_3.inject)(provider_1.spotWorkerStoreKey);
        const isVerifyModalOpen = (0, vue_3.ref)(false);
        const isNoShow = (0, vue_3.ref)(false);
        const spotworker = (0, vue_3.ref)();
        const handleSpotShiftChange = (0, vue_3.inject)(provider_1.handleSpotShiftChangeKey);
        const { init, canVerify, isShiftClaimed, isLoading, roleTimeLabel, handleSubmit, handleDelete, form, formValidation, handleFromTimeChange, handleToTimeChange, isShiftVerified, totalPayment, handleStatusChange, } = (0, useSpotWorkerShiftForm_1.useSpotWorkerShiftForm)();
        const selectedRole = (0, vue_3.computed)(() => {
            const r = props.roleId?.toString();
            if (!r) {
                return;
            }
            return roleStore?.byId(r);
        });
        function handleClose(isSuccess = false) {
            emits("close-shift-modal", isSuccess);
        }
        async function onConfirm() {
            const res = await handleSubmit();
            if (!res.success) {
                alertModal.value?.alert(res.error);
                return;
            }
            handleClose(true);
        }
        function onVerify(noShow) {
            isVerifyModalOpen.value = true;
            isNoShow.value = noShow;
        }
        function onDelete() {
            alertModal.value?.confirm("本当に消去しますか？", async () => {
                const res = await handleDelete();
                if (!res.success) {
                    alertModal.value?.alert(res.error);
                    return;
                }
                if (res.shiftDiff) {
                    handleSpotShiftChange?.(res.shiftDiff);
                }
                handleClose(true);
            });
        }
        async function handleEmitStatusChange(status) {
            if (isLoading.value) {
                return;
            }
            const res = await handleStatusChange(status);
            if (!res.success) {
                alertModal.value?.alert(res.error);
                return;
            }
            handleVerifyClose();
        }
        function handleVerifyClose() {
            isVerifyModalOpen.value = false;
            isNoShow.value = false;
        }
        function handleVerifyError(err) {
            alertModal.value?.alert(err);
        }
        (0, vue_3.watch)(() => [props.roleId, props.selectedShiftId], ([roleIdProp, shiftId]) => {
            const shift = shiftStore?.getShift(shiftId);
            const roleId = roleIdProp || shift?.roleId;
            const role = roleId ? roleStore?.byId(roleId.toString()) : undefined;
            init(role, branch, shift);
            if (shift?.userId) {
                spotworker.value = employeeStore?.getWorker(shift.userId);
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (0, vue_2.createVNode)(AlertModal_vue_1.default, {
                        ref_key: "alertModal",
                        ref: alertModal
                    }, null, 512 /* NEED_PATCH */),
                    (isVerifyModalOpen.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(VerificationModal_vue_1.default, {
                            key: 0,
                            "is-loading": (0, vue_2.unref)(isLoading),
                            "total-payment": (0, vue_2.unref)(totalPayment),
                            "spotworker-name": spotworker.value?.name || '',
                            form: (0, vue_2.unref)(form),
                            "is-no-show": isNoShow.value,
                            onEmitStatus: handleEmitStatusChange,
                            onCloseVerifyModal: handleVerifyClose,
                            onEmitError: handleVerifyError
                        }, null, 8 /* PROPS */, ["is-loading", "total-payment", "spotworker-name", "form", "is-no-show"]))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ])),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    onCloseModal: _cache[14] || (_cache[14] = ($event) => (handleClose())),
                    "has-title-divider": true,
                    "has-footer-divider": false
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [
                        _hoisted_1
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("fieldset", {
                            disabled: (0, vue_2.unref)(isShiftClaimed),
                            class: "content"
                        }, [
                            (selectedRole.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "chip",
                                        style: (0, vue_2.normalizeStyle)({
                                            backgroundColor: selectedRole.value?.color ? `#${selectedRole.value.color}` : '',
                                            color: `#${selectedRole.value?.color ? 'fff' : ''}`,
                                        })
                                    }, (0, vue_2.toDisplayString)(selectedRole.value?.getName()), 5 /* TEXT, STYLE */),
                                    (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(roleTimeLabel)), 1 /* TEXT */)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("label", _hoisted_6, [
                                    (0, vue_2.createTextVNode)(" 業種 "),
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                            id: "industry",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (((0, vue_2.unref)(form).industry) = $event)),
                                            class: (0, vue_2.normalizeClass)(["form-input-spot form-select", { 'is-error': (0, vue_2.unref)(formValidation).industry }])
                                        }, _hoisted_17, 2 /* CLASS */), [
                                            [vue_2.vModelSelect, (0, vue_2.unref)(form).industry]
                                        ])
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Branch Name "),
                            (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                (0, vue_2.createElementVNode)("label", _hoisted_19, [
                                    (0, vue_2.createTextVNode)(" 拠点情報 "),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (((0, vue_2.unref)(form).branchName) = $event)),
                                        class: (0, vue_2.normalizeClass)(["form-input form-input-spot br-5", { 'is-error': (0, vue_2.unref)(formValidation).branchName }]),
                                        type: "text",
                                        name: "branch",
                                        id: "input-branch",
                                        placeholder: "オプラス株式会社"
                                    }, null, 2 /* CLASS */), [
                                        [vue_2.vModelText, (0, vue_2.unref)(form).branchName]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Location "),
                            (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                (0, vue_2.createElementVNode)("label", _hoisted_21, [
                                    (0, vue_2.createTextVNode)(" 住所 "),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (((0, vue_2.unref)(form).location) = $event)),
                                        class: (0, vue_2.normalizeClass)(["form-input form-input-spot br-5", { 'is-error': (0, vue_2.unref)(formValidation).location }]),
                                        type: "text",
                                        name: "location",
                                        id: "input-location",
                                        placeholder: "東京都渋谷区"
                                    }, null, 2 /* CLASS */), [
                                        [vue_2.vModelText, (0, vue_2.unref)(form).location]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Role Name "),
                            (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                (0, vue_2.createElementVNode)("label", _hoisted_23, [
                                    (0, vue_2.createTextVNode)(" ラベル "),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (((0, vue_2.unref)(form).purpose) = $event)),
                                        class: (0, vue_2.normalizeClass)(["form-input form-input-spot br-5", { 'is-error': (0, vue_2.unref)(formValidation).purpose }]),
                                        type: "text",
                                        name: "purpose",
                                        id: "input-purpose",
                                        placeholder: "早番"
                                    }, null, 2 /* CLASS */), [
                                        [vue_2.vModelText, (0, vue_2.unref)(form).purpose]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Date "),
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                (0, vue_2.createElementVNode)("label", _hoisted_25, [
                                    (0, vue_2.createTextVNode)(" 日付 "),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (((0, vue_2.unref)(form).date) = $event)),
                                        class: (0, vue_2.normalizeClass)(["form-input form-input-spot br-5", { 'is-error': (0, vue_2.unref)(formValidation).date }]),
                                        type: "date",
                                        name: "date",
                                        id: "input-date"
                                    }, null, 2 /* CLASS */), [
                                        [vue_2.vModelText, (0, vue_2.unref)(form).date]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Time Range "),
                            (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                (0, vue_2.createElementVNode)("label", _hoisted_27, [
                                    (0, vue_2.createTextVNode)(" 時間 "),
                                    (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => ((0, vue_2.unref)(handleFromTimeChange) && (0, vue_2.unref)(handleFromTimeChange)(...args))),
                                            value: (0, vue_2.unref)(form).from,
                                            class: (0, vue_2.normalizeClass)([{ 'is-error': (0, vue_2.unref)(formValidation).from }, "spot-role-time form-input form-input-spot br-5"]),
                                            type: "text",
                                            name: "from",
                                            placeholder: "09:00"
                                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_29),
                                        (0, vue_2.createTextVNode)(" 〜 "),
                                        (0, vue_2.createElementVNode)("input", {
                                            onChange: _cache[6] || (_cache[6] =
                                                //@ts-ignore
                                                (...args) => ((0, vue_2.unref)(handleToTimeChange) && (0, vue_2.unref)(handleToTimeChange)(...args))),
                                            value: (0, vue_2.unref)(form).to,
                                            class: (0, vue_2.normalizeClass)([{ 'is-error': (0, vue_2.unref)(formValidation).to }, "spot-role-time form-input form-input-spot br-5"]),
                                            type: "text",
                                            name: "to",
                                            placeholder: "18:00"
                                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_30)
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Hourly Wage "),
                            (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                (0, vue_2.createElementVNode)("label", _hoisted_32, [
                                    (0, vue_2.createTextVNode)(" 時給 "),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (((0, vue_2.unref)(form).wage) = $event)),
                                        class: (0, vue_2.normalizeClass)([{ 'is-error': (0, vue_2.unref)(formValidation).wage }, "form-input form-input-spot br-5"]),
                                        type: "number",
                                        name: "wage",
                                        id: "input-wage",
                                        placeholder: "1200"
                                    }, null, 2 /* CLASS */), [
                                        [vue_2.vModelText, (0, vue_2.unref)(form).wage]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Number of Workers Needed "),
                            (!_ctx.selectedShiftId)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_33, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_34, [
                                        (0, vue_2.createTextVNode)(" 募集人数 (最大20人まで) "),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (((0, vue_2.unref)(form).shiftCount) = $event)),
                                            class: (0, vue_2.normalizeClass)([{ 'is-error': (0, vue_2.unref)(formValidation).shiftCount }, "form-input form-input-spot br-5"]),
                                            type: "number",
                                            name: "req-workers",
                                            id: "input-req-workers",
                                            placeholder: "3",
                                            max: 20
                                        }, null, 2 /* CLASS */), [
                                            [vue_2.vModelText, (0, vue_2.unref)(form).shiftCount]
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createCommentVNode)(" Contact Information "),
                            (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                (0, vue_2.createElementVNode)("label", _hoisted_36, [
                                    (0, vue_2.createTextVNode)(" 連絡 "),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (((0, vue_2.unref)(form).contact) = $event)),
                                        class: (0, vue_2.normalizeClass)([{ 'is-error': (0, vue_2.unref)(formValidation).contact }, "form-input form-input-spot br-5"]),
                                        type: "text",
                                        name: "contact",
                                        id: "input-contact",
                                        placeholder: "オプらす 123-456-789"
                                    }, null, 2 /* CLASS */), [
                                        [vue_2.vModelText, (0, vue_2.unref)(form).contact]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Access Information "),
                            (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                (0, vue_2.createElementVNode)("label", _hoisted_38, [
                                    (0, vue_2.createTextVNode)(" アクセス "),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (((0, vue_2.unref)(form).access) = $event)),
                                        class: (0, vue_2.normalizeClass)([{ 'is-error': (0, vue_2.unref)(formValidation).access }, "form-input form-input-spot br-5"]),
                                        type: "text",
                                        name: "access",
                                        id: "input-access",
                                        placeholder: "渋谷駅 徒歩5分"
                                    }, null, 2 /* CLASS */), [
                                        [vue_2.vModelText, (0, vue_2.unref)(form).access]
                                    ])
                                ])
                            ]),
                            (0, vue_2.createCommentVNode)(" Additional Details "),
                            (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                (0, vue_2.createElementVNode)("label", _hoisted_40, [
                                    (0, vue_2.createTextVNode)(" 詳細情報 "),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (((0, vue_2.unref)(form).details) = $event)),
                                        class: (0, vue_2.normalizeClass)([{ 'is-error': (0, vue_2.unref)(formValidation).details }, "form-input form-input-spot br-5"]),
                                        name: "additional",
                                        id: "input-additional",
                                        placeholder: "レジ対応・品出し・清掃業務...",
                                        rows: "5"
                                    }, null, 2 /* CLASS */), [
                                        [vue_2.vModelText, (0, vue_2.unref)(form).details]
                                    ])
                                ])
                            ])
                        ], 8 /* PROPS */, _hoisted_2)
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (!(0, vue_2.unref)(canVerify))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_41, [
                                (props.selectedShiftId && !(0, vue_2.unref)(canVerify))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: 0,
                                        onClick: onDelete,
                                        class: (0, vue_2.normalizeClass)(["text-error c-hand", { loading: (0, vue_2.unref)(isLoading) }])
                                    }, [
                                        (0, vue_2.createVNode)(DeleteIcon_vue_1.default)
                                    ], 2 /* CLASS */))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (!(0, vue_2.unref)(isShiftClaimed))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: 1,
                                        class: (0, vue_2.normalizeClass)([{ loading: (0, vue_2.unref)(isLoading) }, "oplus-modal-btn oplus-alt-confirm-btn spot-work-color"]),
                                        onClick: onConfirm
                                    }, "編集", 2 /* CLASS */))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ]))
                            : ((0, vue_2.unref)(canVerify) && !(0, vue_2.unref)(isShiftVerified) && (0, vue_2.unref)(isShiftClaimed))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_42, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: (0, vue_2.normalizeClass)([{ loading: (0, vue_2.unref)(isLoading) }, "oplus-modal-btn oplus-cancel-btn"]),
                                        onClick: _cache[12] || (_cache[12] = ($event) => (onVerify(true)))
                                    }, _hoisted_44, 2 /* CLASS */),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: (0, vue_2.normalizeClass)([{ loading: (0, vue_2.unref)(isLoading) }, "oplus-modal-btn oplus-alt-confirm-btn spot-work-color"]),
                                        onClick: _cache[13] || (_cache[13] = ($event) => (onVerify(false)))
                                    }, "勤務完了", 2 /* CLASS */)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
